import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=1396e55a&scoped=true&lang=pug&"
import script from "./DashboardPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=1396e55a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396e55a",
  null
  
)

export default component.exports